<template>
  <div class="w640">
    <h3>投放信息管理</h3>
    <el-form
      size="mini"
      label-width="180px"
      :model="formData"
      :rules="rules"
      ref="formData"
    >
      <el-form-item label="用户ID" prop="userId">
        <el-input
          type="text"
          v-model.number="formData.userId"
          placeholder="用户ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="道具订单ID" prop="orderId">
        <el-input
          type="text"
          v-model="formData.orderId"
          placeholder="道具订单ID"
        ></el-input>
      </el-form-item>

      <el-form-item label="目标身份" prop="role">
        <el-select v-model="formData.role">
          <el-option
            v-for="item in roleOption"
            :key="item.value"
            :label="item.label"
            :value="Number(item.value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标设备" prop="targetDevices">
        <el-select v-model="formData.targetDevices">
          <el-option
            v-for="item in deviceOption"
            :key="item.value"
            :label="item.label"
            :value="Number(item.value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="广告位页面" prop="type">
        <el-select v-model="formData.type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="广告素材" prop="imgUrl">
        <!-- action="https://upload.qbox.me/" -->
        <el-upload
          action="https://up-z1.qbox.me/"
          :show-file-list="false"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :data="uploadData"
        >
          <img v-if="formData.imgUrl" :src="formData.imgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <el-input type="hidden" v-model="formData.imgUrl"></el-input>
        </el-upload>
        <p>建议尺寸：1175*500像素；建议大小：10M以内;</p>
      </el-form-item>
      <el-form-item label="跳转地址" prop="url">
        <el-input
          type="text"
          v-model="formData.url"
          placeholder="跳转地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="投放开始时间" prop="startTime">
        <el-date-picker
                v-model="formData.startTime"
                type="datetime"
                placeholder="选择投放开始时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="投放时长(天)" prop="days">
        <el-input
          type="text"
          v-model.number="formData.days"
          placeholder="投放时长(天)"
        ></el-input>
      </el-form-item>
      <el-form-item label="广告标题" prop="title">
        <el-input
          type="text"
          v-model="formData.title"
          placeholder="广告标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="广告文案" prop="content">
        <el-input
          type="textarea"
          rows="5"
          v-model="formData.content"
          placeholder="广告文案"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="priority">
        <el-input
          type="text"
          v-model.number="formData.priority"
          placeholder="活动排序"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button @click="submit">保存</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
const { talentActivity } = api;

export default {
  name: "activityEdit",
  data() {
    return {
      map,
      formData: {
        userId:null,
        orderId:null,
        role: null,
        targetDevices:null,
        startTime:null,
        title: "",
        content: "",
        url: "",
        imgUrl: "",
        days:"",
        priority: 0,
        url: "",
        type: "",
      },
      deviceOption:[
        {
          value: 1,
          label: "PC端",
        },
        {
          value: 2,
          label: "H5端",
        },
        {
          value: 3,
          label: "Android",
        },
        {
          value: 4,
          label: "Ios",
        },
        {
          value: 5,
          label: "Wechat",
        },
      ],
      options: [
        {
          value: 1,
          label: "游客落地页",
        },
        {
          value: 2,
          label: "首页",
        },
        {
          value: 3,
          label: "人才广场",
        },
        {
          value: 4,
          label: "技能服务",
        },
        {
          value: 5,
          label: "热门工作",
        },
        {
          value: 6,
          label: "职位详情页",
        },
        {
          value: 7,
          label: "消息页",
        },
        {
          value: 8,
          label: "我",
        },
        {
          value: 9,
          label: "个人中心",
        },
        {
          value: 10,
          label: "下单页",
        },
      ],
      roleOption:[
        {
          value:1,
          label:'雇主'
        },
        {
          value:2,
          label:'人才'
        },
      ],
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
      isUploading: false,
      isSubmiting: false,
      rules: {
        userId:[
          {
            required: true,
            message: "请填写用户ID",
            trigger: "change",
          },
        ],
        orderId:[
          {
            required: true,
            message: "请填写道具订单ID",
            trigger: "change",
          },
        ],
        role: [
          {
            required: true,
            message: "请选择目标身份",
            trigger: "change",
          },
        ],
        targetDevices: [
          {
            required: true,
            message: "请选择目标设备",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择广告位页面",
            trigger: "change",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请上传广告素材",
            trigger: "change",
          },
        ],
        url: [
          {
            required: true,
            message: "请填写跳转地址",
            trigger: "change",
          },
          {
            type: "url",
            message: "跳转地址链接格式错误",
            trigger: "change",
          },
        ],
        startTime:[
          {
            required: true,
            message: "请选择投放开始时间",
            trigger: "change",
          },
        ],
        days:[
          {
            required: true,
            message: "请填写投放时长(天)",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请填写广告标题",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写广告文案",
            trigger: "change",
          },
        ],
        priority: [
          {
            required: true,
            message: "请填写活动排序",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    id() {
      return this.$route.query.id;
    },
    action() {
      return this.id ? "update" : "create";
    },
  },
  watch: {},
  methods: {
    async getDetail() {
      let obj = {
        id: this.id,
      };
      let {
        data: { code, data },
      } = await talentActivity.detail(obj);
      if (code == 200) {
        this.formData = data;
      }
    },
    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    handleSuccess(res, file) {
      this.formData.imgUrl = `https:\/\/image.duiyou360.com/${res.key}`;
      this.isUploading = false;
    },
    beforeUpload(file) {
      this.isUploading = true;
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;
    },
    submit() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          if (this.isSubmiting || this.isUploading) return false;
          this.isSubmiting = true;
          let obj = this.formData;
          if (this.id) obj.id = this.id;
          let {
            data: { code, data },
          } = await api.talentActivity[this.action](obj);
          let vue = this;
          if (code == 200) {
            this.$message({
              showClose: false,
              message: "保存成功",
              type: "success",
              onClose() {
                if (vue.id) {
                  window.location.reload();
                } else {
                  window.location.href = `/talentActivity`;
                }
              },
            });
          }
          this.isSubmiting = false;
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.id) {
      this.getDetail();
    }
  },
  mounted() {
    this.getToken();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/talentActivity/edit.vue